// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eQks","title":"styles_title__1yY6u"};